import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

require('./task-purpose.scss');
@Component({
  standalone: false,
  selector: 'app-task-purpose',
  templateUrl: './task-purpose.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaskPurposeComponent implements OnInit, OnChanges {

  @Input() purpose: any;
  @Input() isBundle: boolean;
  @Input() textClass: any;
  @Input() firstLetterOnly: boolean;

  public text: any;

  constructor() {
  }

  ngOnInit() {
    if (this.purpose) {
      this.setText();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.purpose && !changes.purpose.isFirstChange()) {
      if (this.purpose) {
        this.setText();
      }
    }
  }

  private setText() {
    let text = '';
    text += (this.firstLetterOnly ? this.purpose.charAt(0) : this.purpose);

    this.text = text;
  }

}
